module.exports = __webpack_public_path__ + "static/media/logo-freighthub.c21ebfc7.png";